import React from 'react';
import { ThemeProvider, CssBaseline } from '@mui/material';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { Toaster } from 'react-hot-toast';
import theme from './styles/theme';
import Layout from './components/Layout/Layout';
import HomePage from './pages/HomePage/HomePage';
import SearchPage from './pages/SearchPage/SearchPage';
import DocumentPage from './pages/DocumentPage/DocumentPage';
import AuthPage from './pages/AuthPage/AuthPage';
import ValidationPage from './pages/ValidationPage/ValidationPage';

function App() {
  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />
      <Router>
        <Layout>
          <Routes>
            <Route path="/" element={<HomePage />} />
            <Route path="/consulta" element={<SearchPage />} />
            <Route path="/documentos/:servidorId" element={<DocumentPage />} />
            <Route path="/validar-email" element={<ValidationPage />} />
            <Route path="/auth/:token" element={<AuthPage />} />
            <Route path="*" element={<Navigate to="/" />} />
          </Routes>
        </Layout>
        <Toaster 
          position="top-right"
          toastOptions={{
            duration: 4000,
            style: {
              background: '#363636',
              color: '#fff',
            },
          }}
        />
      </Router>
    </ThemeProvider>
  );
}

export default App;